import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { WegoAdminModel } from './wegoadmin.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';


@Injectable()
export class WegoAdminService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetPersonList(input?: DataListModel): Observable<IAPIResponse> {
    let getWegoAdminUrl = WeGoConfig.API_GET_WEGOADMIN_PERSON_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getWegoAdminUrl = getWegoAdminUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWegoAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetWegoAdminList(input?: DataListModel): Observable<IAPIResponse> {
    let getWegoAdminUrl = WeGoConfig.API_GET_WEGOADMIN_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getWegoAdminUrl = getWegoAdminUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWegoAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public AddWegoAdmin(personHashId: string): Observable<IAPIResponse> {
    let getWegoAdminUrl = WeGoConfig.API_GET_WEGOADMIN + "?personHashId=" + personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWegoAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public DeleteWegoAdmin(selectedwegoAdminList: string[]): Observable<IAPIResponse> {

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_DELETE_WEGOADMIN, selectedwegoAdminList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public ExportWegoAdminList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getWegoAdminUrl = WeGoConfig.API_EXPORT_WEGOADMIN_LIST + "?" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWegoAdminUrl, options);
  }
  public InActiveWegoAdmin(wegoAdminHashId: string): Observable<IAPIResponse> {
    let getWegoAdminUrl = WeGoConfig.API_GET_INACTIVEWEGOADMIN + "?wegoAdminHashId=" + wegoAdminHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWegoAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaCookies(): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIES_WEGOADMIN;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKeys(): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_KEYS_WEGOADMIN;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetTwoFAValidityDays(): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_GET_TWOFA_KEYS_WEGOADMIN;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateTwoFAValidityDays(Days: string): Observable<IAPIResponse> {

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_UPDATE_WEGOADMIN_TWOFA_VALIDITY + "?Days=" + Days, null, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/wegoadminlist/models/wegoadmin.service.ts